module.exports = __webpack_public_path__ + "img/43-min.29d562ff.jpg";